import { useSelector } from "react-redux";

const useConfig = () => {

    const { config } = useSelector(state=> state.general)    
    if(config.theme==='mortrack') document.getElementById("favicon").href=process.env.PUBLIC_URL + '/favicon_mortrac.png'
    return config;
}

export default useConfig;